import type { ComponentType } from "react";
import {
  CareersSections,
  CompanySections,
  ContactSections,
  HomeSections,
  LegalPage,
  PlatformSections,
  SolutionsSections,
  defaultCareersContent,
  defaultCompanyContent,
  defaultContactContent,
  defaultGovDataRequestContent,
  defaultHomeContent,
  defaultPlatformContent,
  defaultPrivacyContent,
  defaultSolutionsContent,
  defaultTermsContent,
} from "@quintara/site-kit";

// Maps a CMS slug to its baked-in default content (used to seed a page that
// has never been edited) and its site-kit renderer (used for the live
// preview). content is treated as opaque JSON here; the renderer knows its
// own shape.
type AnyContent = Record<string, unknown>;

interface Entry {
  default: AnyContent;
  Preview: ComponentType<{ content: never }>;
}

const asContent = (c: unknown) => c as AnyContent;
const asPreview = (c: unknown) => c as ComponentType<{ content: never }>;

export const PAGE_KIT: Record<string, Entry> = {
  home: { default: asContent(defaultHomeContent), Preview: asPreview(HomeSections) },
  company: { default: asContent(defaultCompanyContent), Preview: asPreview(CompanySections) },
  solutions: { default: asContent(defaultSolutionsContent), Preview: asPreview(SolutionsSections) },
  platform: { default: asContent(defaultPlatformContent), Preview: asPreview(PlatformSections) },
  privacy: { default: asContent(defaultPrivacyContent), Preview: asPreview(LegalPage) },
  terms: { default: asContent(defaultTermsContent), Preview: asPreview(LegalPage) },
  "government-data-request-policy": {
    default: asContent(defaultGovDataRequestContent),
    Preview: asPreview(LegalPage),
  },
  contact: { default: asContent(defaultContactContent), Preview: asPreview(ContactSections) },
  careers: { default: asContent(defaultCareersContent), Preview: asPreview(CareersSections) },
};
